import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { SIGN_IN } from 'config/url';

import Field from 'components/Field';
import Button from 'components/Button';

const PasswordForgotten = ({onSubmit}) => {
  const { handleSubmit, register, formState: { errors } } = useForm();
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Field label="Email" type="text"
        register={
          register("email", {
            required: true,
          })
        } />
      <div className="has-text-centered">
        <Button type="submit" className="is-primary">
          Envoyer le mot de passe par email
        </Button>
      </div>
      <div className="has-text-centered mt-5">
        <Link to={SIGN_IN}>
          Se connecter ?
        </Link>
      </div>
    </form>
  );
}

export default PasswordForgotten;